import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { SampleMedia } from '../models/sampleMedia.model';

@Injectable({
    providedIn: 'root'
})
export class SampleMediaService extends GridService<SampleMedia> {

    constructor(http: HttpClient) {
        super('SampleMedia', http);
    }
}
